import { useSnackbar } from "notistack";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DenseAppBar from "../../components/AppBar";
import Filters from "../../components/Filters";
import PaginationControlled from "../../components/Pagination";
import Placeholder from "../../components/Skeleton";
import Functions from "../../helpers/Functions";
import { Reducers } from "../../Interfaces/Interfaces";
import { getAssignedRequests } from "../../redux/actions/POSAction";
import { getPOSDashboard } from "../../redux/actions/userActions";
import PrimaryTheme from "../../Themes/Primary";
import "./pos.scss";
export default function AssignedPos() {
  const user = useSelector((state: Reducers) => state.user);
  const { enqueueSnackbar } = useSnackbar();
  const alert = useSelector((state: Reducers) => state.alert);
  const dashboard = useSelector((state: Reducers) => state.dashboard);
  const requests = useSelector((state: Reducers) => state.requests);

  const dispatch = useDispatch();
  const history = useHistory();

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [posState, setPosState]: any = React.useState(0);
  const [targetStatus, setTargetStatus]: any = React.useState(0);
  var d = new Date();
  d.setDate(d.getDate() - 2);
  let filterTransaction: any = {
    dateCreatedFrom: d,
    dateCreatedTo: new Date(),
  };
  const dashboardFilter: any = {
    whereCondition: JSON.stringify(filterTransaction),
  };
  let list = requests && requests.items;

  let filter: any = {};
  const paginationConfig = {
    page: page + 1,
    pageSize,
    id: user.id,
    whereCondition: JSON.stringify(filter),
  };

  const handleClear = () => {
    filter = {};
    paginationConfig.whereCondition = JSON.stringify(filter);

    setPosState(0);
    setTargetStatus(0);

    dispatch({
      type: "LOADING",
      payload: true,
    });

    // dispatch(getPOSDashboard(user.id));
    dispatch(getAssignedRequests(paginationConfig));
  };

  const handleReload = () => {
    dispatch({
      type: "STATUS_ALERT",
      payload: false,
    });

    window.location.reload();
  };

  React.useEffect(() => {
    if (posState !== 0) {
      filter.state = posState;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });
      dispatch(getAssignedRequests(paginationConfig));
    }

    if (targetStatus !== 0) {
      filter.targetStatus = targetStatus;
      paginationConfig.whereCondition = JSON.stringify(filter);

      dispatch({
        type: "LOADING",
        payload: true,
      });
      dispatch(getAssignedRequests(paginationConfig));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [posState, dispatch, targetStatus]);

  const getIndexSeed = (index: number) => {
    paginationConfig.page = page + 1;
    return (paginationConfig.page - 1) * paginationConfig.pageSize + index + 1;
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handlePageSizeChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    value: any
  ) => {
    setPageSize(value.props.value);

    paginationConfig.pageSize = value.props.value;
    dispatch(getAssignedRequests(paginationConfig));
  };

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    dispatch(getPOSDashboard(user.id));

    return () => {
      // dispatch({
      //   type: 'DASHBOARD',
      //   payload: {}
      // })
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  React.useEffect(() => {
    dispatch({
      type: "LOADING",
      payload: true,
    });
    dispatch(getAssignedRequests(paginationConfig));

    return () => {
      dispatch({
        type: "REQUESTS",
        payload: {},
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, page]);

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: "ALERT",
          payload: {},
        });

        dispatch(getAssignedRequests(paginationConfig));
      } else {
        handleReload();

        dispatch({
          type: "STATUS_ALERT",
          payload: true,
        });

        dispatch({
          type: "ALERT",
          payload: {},
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert]);

  return (
    <React.Fragment>
      <div
        className="col-md-11 mr-auto ml-auto p-0"
        style={{
          height: "auto",
          position: "relative",
        }}
      >
        <DenseAppBar canGoBack onClick={() => history.goBack()} />
      </div>
      <div
        className="col-md-12 pl-0 pr-0"
        style={{
          backgroundColor: PrimaryTheme.white,
        }}
      >
        <div
          className="col-md-11 ml-auto mr-auto p-0"
          style={{
            backgroundColor: PrimaryTheme.white,
            height: "100vh",
            position: "relative",
          }}
        >
          <h1
            className="mb-5 rec-pos-title"
            style={{
              fontFamily: PrimaryTheme.fonts?.MediumFont,
              textTransform: "uppercase",
              fontSize: PrimaryTheme.fontSizes?.subtitle,
            }}
          >
            Assigned POS
          </h1>

          {/* cards  */}
          <div className="row mb-5" style={{ paddingLeft: "20px" }}>
            <div
              className="col-md col-12"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <h5
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                Approved Agents
              </h5>
              <h2
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                {dashboard.approvedRequests ? dashboard.approvedRequests : 0}
              </h2>
            </div>

            <div
              className="col-md col-12"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <h5
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                Available POS
              </h5>
              <h2
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                {dashboard.unAssignedTerminals
                  ? dashboard.unAssignedTerminals
                  : 0}
              </h2>
            </div>

            <div
              className="col-md col-12"
              style={{
                height: "auto",
                position: "relative",
              }}
            >
              <h5
                className="text-uppercase"
                style={{
                  color: PrimaryTheme.primary,
                }}
              >
                POS Agents Behind
              </h5>
              <h2
                className="text-uppercase text-bold mb-0"
                style={{
                  color: PrimaryTheme.dark,
                  fontFamily: PrimaryTheme.fonts?.MediumFont,
                }}
              >
                N/A
              </h2>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-md-12">
              <Filters
                name="POS Terminals"
                posStateChange={(e: any) => setPosState(e.target.value)}
                posState={posState}
                posTarget={targetStatus}
                posTargetChange={(e: any) => setTargetStatus(e.target.value)}
                isPOS
                onClear={handleClear}
              />
            </div>
          </div>

          <div className="row " style={{ paddingBottom: "100px" }}>
            <div className="col-md-12 mb-3">
              {list ? (
                <React.Fragment>
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead className="thead-primary">
                        <tr
                          style={{
                            textAlign: "center",
                          }}
                        >
                          <th scope="col">S/N</th>
                          <th scope="col">Assigned On</th>
                          <th scope="col">Agent Name</th>
                          <th scope="col">Teller Name</th>
                          <th scope="col">Serial Number</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.length !== 0 &&
                          list?.map((item: any, index: number) => (
                            <tr
                              key={index}
                              style={{
                                textAlign: "center",
                              }}
                            >
                              <th scope="row">{getIndexSeed(index)}</th>
                              <td>
                                {Functions.getDate(item.assignedToAgentOn)}
                              </td>
                              <td>{item.agentName}</td>
                              <td>{item.tellerName}</td>
                              <td>{item.serialNumber}</td>
                              <td>
                                {item.state === 1 && (
                                  <span className="badge badge-pill badge-danger p-2 pl-3 pr-3">
                                    {item.stateName}
                                  </span>
                                )}

                                {item.state === 2 && (
                                  <span className="badge badge-pill badge-success p-2 pl-3 pr-3">
                                    {item.stateName}
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  {list.length === 0 && (
                    <React.Fragment>
                      <p className="text-center mt-3 text-dark w-100">
                        No result
                      </p>
                    </React.Fragment>
                  )}

                  <div className="col-md-12 p-0">
                    {requests.total > pageSize && (
                      <PaginationControlled
                        onPageSizeChange={handlePageSizeChange}
                        onChange={handleChange}
                        page={page}
                        total={requests.total && requests.total}
                        pageSize={pageSize}
                      />
                    )}
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <Placeholder
                      variant="text"
                      width={"100%"}
                      height={50}
                      animation="wave"
                      className="display-inline"
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
